export default "__VITE_ASSET__CiTneQ4H__"